import { InjectionToken, Type } from "@angular/core";
import { IAggregate, ICardData, ICardAction } from "@tylertech/tyler-api-types";
import { AggregateActionResult } from "../services";

export interface ActionReturn
{
    success: boolean;
    action: ICardAction;
}

/**
 * This interface is now representing two different usages; an action and a loader...
 * @deprecated TODO - split usages by purposes.
 */
export interface IAggregateActionHandler
{
    predicate(aggregate: IAggregate, cardData: ICardData, action: ICardAction): boolean;
    execute(aggregate: IAggregate, cardData: ICardData, action: ICardAction): Promise<AggregateActionResult>;
    load(aggregate: IAggregate, cardData: ICardData, action: ICardAction): void;
}

export type ActionHandlerType = Type<IAggregateActionHandler>;

export const AGGREGATE_ACTION_HANDLERS = new InjectionToken<ReadonlyArray<ReadonlyArray<ActionHandlerType>>>("AGGREGATE_ACTION_HANDLERS");
